<template>
  <div class="auto_1280">
    <div class="party-build">
      <ul class="ul">
        <li v-for="( item, index ) in partybuildList" :key="index" @click="goDetail(item.id)" class="clearfix li">
          <div class="content">
            <div class="date">
              <div class="day">{{index + 1}}</div>
              <!-- <div class="ym">{{item.createTime | ym}}</div> -->
            </div>
            <div class="title dot">{{item.title}}</div>
            <div class="txt dot3">{{item.intro}}</div>
            <div class="more" v-if="lan === 0">了解更多</div>
            <div class="more" v-else-if="lan === 1">Learn More</div>
          </div>
          <div class="pic"><img :src="item.coverImg" alt=""></div>
        </li>
      </ul>
      <div class="pager" v-if="partybuildList.length > 0">
        <span class="p_page">
          <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
          <em class="num">
            <template v-for="( num, index ) in pageList">
              <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
            </template>
          </em>
          <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PartyBuild',
  filters: {
    day (value) {
      const date = new Date(value)
      return ('0' + date.getDate()).slice(-2)
    },
    ym (value) {
      const date = new Date(value)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      return year + '.' + month
    }
  },
  data () {
    return {
      partybuildList: [],
      articleTypeId: 17,
      pageList: [],
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  mounted () {
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      // 获取当前栏目的栏目id，用于当前栏目的数据获取
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.partybuildList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan }, r => {
        if (r.total && r.data) {
          self.total = r.total
          r.data.forEach((item) => {
            self.partybuildList.push(item)
          })
        }
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    initEL () {},
    goDetail (id) {
      const index = this.$route.path.lastIndexOf('/')
      // 用于从详情页跳回到列表页
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/aboutus/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: this.articleTypeId,
          id
        }
      })
    }
  }
}
</script>
<style scoped>
.auto_1280{z-index: 0; position: relative;}
.party-build{padding: 0 0 5% 0; z-index: 0; position: relative;}
.party-build .ul{z-index: 0; position: relative;}
.party-build .pic{float: right; width: 27.34%; max-width: 350px; max-height: 220px; overflow: hidden;}
.party-build .pic img{width: 100%;}
.party-build .content{float: left; width: 72.66%; position: relative; padding-left: 9.76%; padding-right: 12.5%;}
.party-build .li{padding: 4% 0; border-bottom: 1px solid #eee; cursor: pointer; z-index: 0; position: relative;}
.party-build .date{position: absolute; top: 0; left: 0; width: 80px; height: 80px; border: 1px solid rgba(228,0,127,0.1); text-align: center;}
.party-build .day{font-size: 40px; color: #e4007f; height: 80px; line-height: 80px;}
.party-build .ym{font-size: 14px; color: #e4007f;}
.party-build .title{font-size: 20px; color: #333;}
.party-build .txt{font-weight: lighter; line-height: 2; color: #666; margin: 3% 0 6%; word-break: break-word;}
.party-build .more{font-weight: lighter; color: #e4007f; background: url(../../assets/a_next.png)no-repeat right center; padding-right: 15px; display: inline-block;}
@media(max-width: 960px){
  .party-build .content{padding-left: 90px; padding-right: 5%;}
}
@media(max-width: 768px){
  .party-build .title{font-size: 18px;}
  .party-build .date{width: 70px; height: 70px;}
  .party-build .day{font-size: 32px;}
  .party-build .ym{font-size: 12px;}
}
@media(max-width: 640px){
  .party-build .pic{width: 100%; float: none; padding: 2% 0; max-width: none; max-height: none;}
  .party-build .content{width: 100%; float: none; padding-right: 0;}
}
</style>
